<template>
  <base-header
    v-if="hasHeaderContent"
    :type="''"
    style="background-color: #f8f9fe !important"
  >
    <div v-if="meta && meta.serviceRequestNumber">
      <h4>Service Request Number - {{ meta.serviceRequestNumber }}</h4>
    </div>
    <div v-if="meta && meta.averagePoints">
      <h4>
        Vendor's Average Points For This Request - {{ meta.averagePoints }}
        <i class="el-icon-coin"></i>
      </h4>
    </div>
  </base-header>
</template>
<script>
export default {
  props: {
    buttons: {
      type: Array,
      default: () => []
    },
    meta: {
      type: Object,
      default: () => {}
    }
  },
  data: () => {
    return {};
  },
  computed: {
    hasHeaderContent() {
      return Boolean(
        (this.meta && this.meta.serviceRequestNumber) ||
          (this.meta && this.meta.averagePoints)
      );
    }
  },
  methods: {
    showFilters() {
      this.$emit("showFilters");
    }
  }
};
</script>
